import { Alert, Box, Icon, Text } from '@factorialco/deprecated-design-system'

import { dateToString } from 'modules/core/lib/dates'
import i18n from 'modules/core/lib/i18n'

interface Props {
  isClosed: boolean
  lockedAt: moment.Moment | Date | null
  canToggleLock: boolean
}

function PayrollRunStatusAlert({ isClosed, lockedAt, canToggleLock }: Props) {
  if (!isClosed && !lockedAt) {
    return null
  }

  const icon = <Icon.Medium icon="lightbulb" color="viridian1000" />

  let message: React.ReactNode

  if (isClosed) {
    message = i18n.t('compensations.PayrollRunCompensationsList.period_closed_alert')
  } else if (lockedAt) {
    const formattedDate = dateToString(lockedAt, 'ui_full_month_year')
    message = canToggleLock
      ? i18n.tView('compensations.PayrollRunCompensationsList.period_locked_alert', {
          date: <strong>{formattedDate}</strong>,
        })
      : i18n.t('compensations.PayrollRunCompensationsList.period_locked_alert_non_admins')
  }

  return (
    <Alert color="info">
      <Box flexDirection="row" alignItems="flexStart" gap="s12">
        {icon}
        <Text.Normal color="grey1000">{message}</Text.Normal>
      </Box>
    </Alert>
  )
}

export default PayrollRunStatusAlert
